import { ScreenshotCanvasType } from 'types/error-log';
import { isErrorLogScreenshot } from 'utils/error-log/is-error-log-screenshot';

export function toScreenshotDataUrl(
  canvas: ScreenshotCanvasType,
  maxChars: number,
  qualities: readonly number[]
): string | null {
  for (let index = 0; index < qualities.length; index += 1) {
    const dataUrl = canvas.toDataURL('image/jpeg', qualities[index]);
    if (isErrorLogScreenshot(dataUrl) && dataUrl.length <= maxChars) {
      return dataUrl;
    }
  }
  return null;
}
